(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('documentLibraryPreviewActionBar', documentLibraryPreviewActionBar);

    function documentLibraryPreviewActionBar(lodash, $templateCache) {
        return {
            restrict: 'E',
            controller: documentLibraryPreviewActionBarCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                data: '=?',
                options: '=?',
            },
            template: function(elem, attr) {
                var templateUrl = lodash.get(attr, 'templateUrl', '');
                if (templateUrl.length > 0) {
                    var template = $templateCache.get(templateUrl);
                    if (lodash.isEmpty(template)) {
                        return $templateCache.get('common/app/components/document-library/preview-action-bar');
                    }
                    return template;
                }

                return $templateCache.get('common/app/components/document-library/preview-action-bar');
            }
        };
    }

    function documentLibraryPreviewActionBarCtrl(ListFilterStateFactory, $timeout, lodash) {
        var vm = this;
        this.$onInit = function() {
            vm.showList = showList;

            $timeout(function() {
                init();
            });
        }

        function init() {
            var listFilterService = ListFilterStateFactory.get();
            listFilterService.sync(vm);
        }

        function showList() {
            var listFilterIdentifier = lodash.get(vm.options, 'identifier', null);

            var listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
            listFilterService.hideDetailView();
        }
    }
})();